import AppHeader from '../AppHeader'

export default {
  name: 'message-sent-manager',
  computed: {
  },
  methods: {
    goTop: function () {
      this.$router.push({ path: '/'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/message-sent-manager.js